// extracted by mini-css-extract-plugin
export var box = "_5f-0";
export var check = "_5f-1";
export var checkboxButton = "_5f-6";
export var checkboxGroup = "_5f-5";
export var disabled = "_5f-7";
export var ghost = "_5f-9";
export var input = "_5f-2";
export var label = "_5f-4";
export var normal = "_5f-8";
export var uncheck = "_5f-3";